let macAltKey2Text = new Map()
macAltKey2Text.set("a", "å")
macAltKey2Text.set("b", "∫")
macAltKey2Text.set("c", "ç")
macAltKey2Text.set("d", "∂")
macAltKey2Text.set("e", "´")
macAltKey2Text.set("f", "ƒ")
macAltKey2Text.set("g", "©")
macAltKey2Text.set("h", "˙")
macAltKey2Text.set("i", "ˆ")
macAltKey2Text.set("j", "∆")
macAltKey2Text.set("k", "˚")
macAltKey2Text.set("l", "¬")
macAltKey2Text.set("m", "µ")
macAltKey2Text.set("n", "Dead") // alt + n in xtermjs is "Dead" but not "˜"
macAltKey2Text.set("o", "ø")
macAltKey2Text.set("p", "π")
macAltKey2Text.set("q", "œ")
macAltKey2Text.set("r", "®")
macAltKey2Text.set("s", "ß")
macAltKey2Text.set("t", "†")
macAltKey2Text.set("u", "¨")
macAltKey2Text.set("v", "√")
macAltKey2Text.set("w", "∑")
macAltKey2Text.set("x", "≈")
macAltKey2Text.set("y", "¥")
macAltKey2Text.set("z", "Ω")
macAltKey2Text.set("0", "º")
macAltKey2Text.set("1", "¡")
macAltKey2Text.set("2", "™")
macAltKey2Text.set("3", "£")
macAltKey2Text.set("4", "¢")
macAltKey2Text.set("5", "∞")
macAltKey2Text.set("6", "§")
macAltKey2Text.set("7", "¶")
macAltKey2Text.set("8", "•")
macAltKey2Text.set("9", "ª")
macAltKey2Text.set("+", "≠")
macAltKey2Text.set("-", "–")
macAltKey2Text.set("[", "“")
macAltKey2Text.set("]", "‘")
macAltKey2Text.set("\\", "«")
macAltKey2Text.set(";", "…")
macAltKey2Text.set("'", "æ")
macAltKey2Text.set(",", "≤")
macAltKey2Text.set(".", "≥")
macAltKey2Text.set("/", "set")


let macAltText2Key = new Map()
macAltText2Key.set("å", "a")
macAltText2Key.set("∫", "b")
macAltText2Key.set("ç", "c")
macAltText2Key.set("∂", "d")
macAltText2Key.set("´", "e")
macAltText2Key.set("ƒ", "f")
macAltText2Key.set("©", "g")
macAltText2Key.set("˙", "h")
macAltText2Key.set("ˆ", "i")
macAltText2Key.set("∆", "j")
macAltText2Key.set("˚", "k")
macAltText2Key.set("¬", "l")
macAltText2Key.set("µ", "m")
macAltText2Key.set("Dead", "n")
macAltText2Key.set("ø", "o")
macAltText2Key.set("π", "p")
macAltText2Key.set("œ", "q")
macAltText2Key.set("®", "r")
macAltText2Key.set("ß", "s")
macAltText2Key.set("†", "t")
macAltText2Key.set("¨", "u")
macAltText2Key.set("√", "v")
macAltText2Key.set("∑", "w")
macAltText2Key.set("≈", "x")
macAltText2Key.set("¥", "y")
macAltText2Key.set("Ω", "z")
macAltText2Key.set("º", "0")
macAltText2Key.set("¡", "1")
macAltText2Key.set("™", "2")
macAltText2Key.set("£", "3")
macAltText2Key.set("¢", "4")
macAltText2Key.set("∞", "5")
macAltText2Key.set("§", "6")
macAltText2Key.set("¶", "7")
macAltText2Key.set("•", "8")
macAltText2Key.set("ª", "9")
macAltText2Key.set("≠", "+")
macAltText2Key.set("–", "-")
macAltText2Key.set("“", "[")
macAltText2Key.set("‘", "]")
macAltText2Key.set("«", "\\")
macAltText2Key.set("…", ";")
macAltText2Key.set("æ", "'")
macAltText2Key.set("≤", ",")
macAltText2Key.set("≥", ".")
macAltText2Key.set("set", "/")

function getKey(text) {
    return macAltText2Key.has(text) ? macAltText2Key.get(text) : text
}
function getText(key) {
    return macAltKey2Text.has(key) ? macAltKey2Text.get(key) : key
}

export default {
    getKey,
    getText,
    macAltKey2Text,
    macAltText2Key,
}
